/*
 * Copyright (c)  CYBERKOALA LLC 2026.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */
import { Room, RoomEvent, Track, TrackPublication } from 'livekit-client';
import { useEffect } from 'react';
import { useCall } from '@/context/call-context/use-call';
import { useGlobalSFX } from '@/context/sfx-context/use-sfx.ts';

export function useScreenShareSync(room?: Room) {
  const { setScreenSharing } = useCall();
  const sfx = useGlobalSFX();

  useEffect(() => {
    if (!room) return;

    const recompute = () => {
      const pub = room.localParticipant.getTrackPublication(Track.Source.ScreenShare);
      setScreenSharing(!!pub);
    };

    recompute();

    const lp = room.localParticipant;

    const onPub = (pub: TrackPublication) => {
      if (pub.source === Track.Source.ScreenShare) {
        recompute();
        sfx.screenShareOn.play();
      }
    };
    const onUnpub = (pub: TrackPublication) => {
      if (pub.source === Track.Source.ScreenShare) {
        recompute();
        sfx.screenShareOff.play();
      }
    };

    lp.on(RoomEvent.LocalTrackPublished, onPub);
    lp.on(RoomEvent.LocalTrackUnpublished, onUnpub);

    return () => {
      lp.off(RoomEvent.LocalTrackPublished, onPub);
      lp.off(RoomEvent.LocalTrackUnpublished, onUnpub);
    };
  }, [room, setScreenSharing]);
}
